<template>
<div>
	<div class="profile-orders">
		<div
			class="wrapper-btn-back"
			:style="`background-color:${globalColors.primary}`"
		>
			<button 
				class="profile-orders-back"
				@click="$emit('close-modal')">
				<img 
					src="/static/img/arrow-back.svg" 
					alt="ir hacia atras"
					class="arrow-back">
			</button>
			<p
				class="bold txt-center title-btn"
			>MIS PEDIDOS</p>
		</div>
		<div
			class="profile-orders-title mb-2 title-bold"
			:style="`color:${globalColors.primary}`"
		>MIS PEDIDOS</div>
		<div>
			<div class="order-status-selectable">
				<SelectComponent
					placeholder="Estados de pedidos"
					item-text="name"
					item-value="id"
					:options="status"
					:value="currentStatus"
					:style="`background-color:${globalColors.titulo}`"
					class="order-status-selecter"
					@input="handleTab"
				/>
			</div>
			<responsible-table
				class="responsive-table"
				:break-point="950"
				:columns="columns"
				:rows="rows"
			>
				<template slot="row" slot-scope="{ row }">
					<td class="row cell1">{{row.date}}</td>
					<td class="row cell2">
						<span v-if="isMovil" class="label-movil">Pedido: </span>
						{{row.order}}
					</td>
					<td class="row cell3">
						<span v-if="isMovil" class="label-movil">Total: </span>{{row.total}}
					</td>
					<td class="row cell4">{{row.status}}</td>
					<td class="row cell5">{{row.method}}</td>
					<td class="row cell6">
						<span v-if="isMovil" class="label-movil">Entrega: </span>
						{{row.pickUpName}}
					</td>
					<td class="row cell7">{{row.orderStatus}}</td>
					<td class="row actions">
						<button
							class="btn-table"
							title="Detalle de pedido"
							type="button"
							@click="detail(row.id)"
						>
							<img 
								:src="view" 
								alt="Ver detalle"
								class="table-view">
						</button>
						<button
							v-if="row.voucher"
							class="btn-table"
							title="Adjuntar constancia"
							type="button"
							@click="deposit(row.id)"
						>
							<img 
								:src="upload" 
								alt="Cargar_constancia_pago"
								class="table-view">
						</button>
					</td>
				</template>
			</responsible-table>
		</div>
	</div>
</div>
</template>
<script>
import responsibleTable from 'responsive-table-dl';

function handleTab(statusId) {
	this.$emit('change-tab', statusId);
}

function detail(id) {
	this.$emit('detail', id);
}

function deposit(id) {
	this.$emit('deposit', id);
}

function cancel(id) {
	this.$emit('cancel', id);
}

function isMovil() {
	return window.innerWidth <= this.breakPoint;
}

function data() {
	return {
		breakPoint: 950,
		columns: [
			{ title: 'Fecha de pedido', movil: true },
			{ title: 'Número de pedido', movil: false },
			{ title: 'Total pedido', movil: false },
			{ title: 'Estado de pago', movil: true },
			{ title: 'Método de pago', movil: true },
			{ title: 'Modo de entrega', movil: false },
			{ title: 'Estado', movil: true },
			{ title: 'Acción', movil: false },
		],
		view: '/static/img/view.svg',
		upload: '/static/img/icons/upload.svg',
	};
}

export default {
	name: 'orders',
	components: {
		responsibleTable,
		SelectComponent: () => import('@/components/selectComponent'),
	},
	computed: {
		isMovil,
	},
	data,
	methods: {
		cancel,
		deposit,
		detail,
		handleTab,
	},
	props: {
		currentStatus: null,
		headers: {
			type: Array,
			default: () => [],
		},
		rows: {
			type: Array,
			default: () => [],
		},
		headersMobile: {
			type: Array,
			default: () => [],
		},
		status: {
			type: Array,
			default: () => [],
		},
	},
};
</script>
<style lang="scss" scoped>
	.profile-orders {
		padding: 5rem;

		.wrapper-btn-back {
			display: none;
			margin-bottom: 3.6rem;
			padding: 0.1rem 1rem;
			position: relative;
		}

		&-title {
			color: color(defaultOrange);
			font-size: size(maxsmall);
		}

		.arrow-back {
			height: 1.5rem;
		}

		.title-btn {
			color: color(white);
			font-size: size(small);
		}

		&-back {
			background: none;
			border: none;
			outline: none;
			position: absolute;
			top: 33%;
		}

		.title-bold {
			font-family: font(avenirBold) !important;
			font-size: size(normal);
		}
	}

	@media screen and (max-width: 768px) {
		.profile-orders {
			padding: 0;

			.wrapper-btn-back {
				display: block;
			}

			&-title {
				display: none;
			}

			&-btn {
				margin: 1.5rem auto;
			}
		}
	}

	.order-status-selectable {
		width: 25rem;
	}

	.order-status-selecter {
		border-top-left-radius: 1.5rem;
    	border-top-right-radius: 1.5rem;
	}

	.row {
		padding: 0.5rem 1rem;
		text-align: center;
	}

	.table-view {
		cursor: pointer;
		height: 1.5rem;
	}
	.btn-table {
		border: none;
		background: none;
		outline: none;
	}
	.cell1, .cell2 {
		grid-column: 1/2;
		grid-row: 1;
	}
	.cell2 {
		align-items: center;
		display: flex;
		grid-row: 2;
		justify-content: center;
	}

	.cell4, .cell3 {
		grid-column: 2/3;
		grid-row: 1;
	}
	.cell3 {
		align-items: center;
		display: flex;
		grid-row: 2;
		justify-content: center;
	}

	.cell5, .cell6 {
		grid-column: 3/4;
		grid-row: 1;
	}
	.cell6 {
		align-items: center;
		display: flex;
		grid-row: 2;
		justify-content: center;
		white-space: nowrap;
	}

	.cell7, .actions {
		grid-column: 4/5;
		grid-row: 1;
	}
	.actions {
		align-items: center;
		display: flex;
		grid-row: 2;
		justify-content: center;
	}

	@media (min-width: 950px) {
		.cell1, .cell2, .cell3, .cell4, .cell5, .cell6, .cell7 {
			display: table-cell;
		}
	}

	.label-movil {
		font-family: font(avenirBold);
		color: color(blackBold);
	}
</style>



// WEBPACK FOOTER //
// orders.vue?fea7bd2a